import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import React, { useState, useRef } from "react";
import * as Yup from "yup";
import { ERROR_MSG } from "./contextVariables";
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from "./CommonAxios";
import { config } from "./CommonURLS";
import CommonReactTable from "./CommonReactTable";
import TableActions from "../RusaComponents/components/TableActions";

function SchemewiseReport() {
  const tableRef = useRef(null);
  const [search, setSearch] = useState("");

  const validationSchema = Yup.object({
    repoType: Yup.string().required(ERROR_MSG),
    scheme: Yup.mixed().when("repoType", {
      is: "Fin",
      then: () => Yup.string().required(ERROR_MSG),
      otherwise: () => Yup.string().notRequired(),
    }),
  });
  const schemeFormik = useFormik({
    initialValues: {
      repoType: "",
      scheme: "",
    },
    validationSchema,
    onSubmit: (val) => {
      if (val?.repoType === "Inst") {
        GetInstRepoDetails();
      }
      if (val?.repoType === "Fin") {
        GetFinRepoDetails(val?.scheme);
      }
    },
  });
  const [instRepoData, setInstRepoData] = useState([]);
  const [instRepoTable, setInstRepoTable] = useState(false);
  function GetInstRepoDetails() {
    let url = `${config.url.API_URL}getRusaInstDtlsReport`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setInstRepoData(res.data.data);
        setInstRepoTable(true);
        setFinRepoTable(false);
      } else {
        setInstRepoData([]);
        setInstRepoTable(true);
        setFinRepoTable(false);
      }
    });
  }

  const [finRepoData, setFinRepoData] = useState([]);
  const [finRepoTable, setFinRepoTable] = useState(false);
  function GetFinRepoDetails(scheme) {
    const url = `${config.url.API_URL}getFinancialDetailsReport?rusa_phase=${scheme}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setFinRepoData(res.data.data);
        setFinRepoTable(true);
        setInstRepoTable(false);
      } else {
        setFinRepoData([]);
        setFinRepoTable(true);
        setInstRepoTable(false);
      }
    });
  }
  const monthMap = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    10: "October",
    11: "November",
    12: "December",
  };

  const instColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "inst_name",
      header: "Inst Name",
      accessorKey: "inst_name",
      Footer: "",
    },
    {
      id: "aishe_code",
      header: "AISHE Code",
      accessorKey: "aishe_code",
      Footer: "",
    },
    {
      id: "dist_name",
      header: "District Name",
      accessorKey: "dist_name",
      Footer: "",
    },
    {
      id: "coll_nature_name",
      header: "Type of Institution",
      accessorKey: "coll_nature_name",
      Footer: "",
    },
    {
      id: "principal_name",
      header: "Principal Name",
      accessorKey: "principal_name",
      Footer: "",
    },
    {
      id: "principal_mobile",
      header: "Principal Mobile",
      accessorKey: "principal_mobile",
      Footer: "",
    },
    {
      id: "coordinator_name",
      header: "Coordinator Name",
      accessorKey: "coordinator_name",
      Footer: "",
    },
    {
      id: "coordinator_mobile",
      header: "Coordinator Mobile",
      accessorKey: "coordinator_mobile",
      Footer: "",
    },
    {
      id: "coll_mail",
      header: "College Email",
      accessorKey: "coll_mail",
      Footer: "",
    },
    {
      id: "coll_website",
      header: "College Website",
      accessorKey: "coll_website",
      Footer: "",
    },
  ];

  const transformedData = Object.values(
    finRepoData.reduce((acc, item) => {
      const key = `${item.coll_aishe_code}_${item.comp_id}`;

      if (!acc[key]) {
        acc[key] = {
          inst_name: item.inst_name,
          rusa_phase: item.rusa_phase,
          comp_name: item.comp_name,

          // New
          new_amount_allocated: 0,
          new_amount_utilised: 0,
          new_balance_amount: 0,

          // Renovation
          renovation_amount_allocated: 0,
          renovation_amount_utilised: 0,
          renovation_balance_amount: 0,

          // Equipment
          equipment_amount_allocated: 0,
          equipment_amount_utilised: 0,
          equipment_balance_amount: 0,

          // Soft
          soft_amount_allocated: 0,
          soft_amount_utilised: 0,
          soft_balance_amount: 0,

          // ✅ TOTALS (right side)
          total_allocated: 0,
          total_utilised: 0,
          total_balance: 0,
        };
      }

      const allocated = Number(item.amount_allocated || 0);
      const utilised = Number(item.amount_utilised || 0);
      const balance = Number(item.balance_amount || 0);

      if (item.sub_comp_name === "New Construction") {
        acc[key].new_amount_allocated = allocated;
        acc[key].new_amount_utilised = utilised;
        acc[key].new_balance_amount = balance;
      }

      if (item.sub_comp_name === "Renovation/Upgradation") {
        acc[key].renovation_amount_allocated = allocated;
        acc[key].renovation_amount_utilised = utilised;
        acc[key].renovation_balance_amount = balance;
      }

      if (item.sub_comp_name === "Equipment") {
        acc[key].equipment_amount_allocated = allocated;
        acc[key].equipment_amount_utilised = utilised;
        acc[key].equipment_balance_amount = balance;
      }

      if (item.sub_comp_name === "Soft Components") {
        acc[key].soft_amount_allocated = allocated;
        acc[key].soft_amount_utilised = utilised;
        acc[key].soft_balance_amount = balance;
      }

      // ✅ GRAND TOTAL (based on headings)
      acc[key].total_allocated += allocated;
      acc[key].total_utilised += utilised;
      acc[key].total_balance += balance;

      return acc;
    }, {}),
  );

  // const filteredData = transformedData.filter((row) =>
  //   row.inst_name?.toLowerCase().includes(search.toLowerCase()),
  // );
  // const filteredData = transformedData.filter((row) =>
  //   Object.values(row).some((val) =>
  //     String(val).toLowerCase().includes(search.toLowerCase()),
  //   ),
  // );
  const filteredData = transformedData.filter((row) =>
    [row.inst_name, row.comp_name, row.rusa_phase].some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase()),
    ),
  );

  const getTotal = (data, key) => {
    return data.reduce((sum, row) => {
      return sum + Number(row[key] || 0);
    }, 0);
  };

  const thStyle = {
    backgroundColor: "#3b1600",
    color: "#ffffff",
    verticalAlign: "middle",
    textAlign: "center",
  };
  return (
    <>
      <bie.Container fluid className="px-0">
        <bie.Container className="px-0 pt-3 mw-100 pb-5">
          <h4 className="mb-3">Scheme wise Report</h4>
          <FormikProvider value={schemeFormik}>
            <Form
              onSubmit={schemeFormik.handleSubmit}
              onChange={schemeFormik.handleChange}
            >
              <bie.Row className="g-3">
                <div className="d-flex flex-nowrap align-items-start w-100">
                  {/* Report Type */}
                  <div style={{ width: "30%" }}>
                    <label>Report Type</label>
                    <Field
                      as="select"
                      name="repoType"
                      className="form-control"
                      onChange={() => {
                        schemeFormik.setFieldValue("scheme", "");
                        setFinRepoTable(false);
                        setInstRepoTable(false);
                      }}
                    >
                      <option value="">--select--</option>
                      <option value="Inst">Institution Details</option>
                      <option value="Fin">Financial Details</option>
                    </Field>

                    <div
                      className="text-danger small"
                      style={{ minHeight: "18px" }}
                    >
                      <ErrorMessage name="repoType" />
                    </div>
                  </div>

                  {/* Scheme */}
                  {schemeFormik.values.repoType === "Fin" && (
                    <div style={{ width: "30%", marginLeft: "1rem" }}>
                      <label>Scheme</label>
                      <Field
                        as="select"
                        name="scheme"
                        className="form-control"
                        onChange={() => {
                          setFinRepoTable(false);
                          setInstRepoTable(false);
                        }}
                      >
                        <option value="">--select--</option>
                        <option value="RUSA 1">RUSA 1</option>
                        <option value="RUSA 2">RUSA 2</option>
                        <option value="PMUSHA">PMUSHA</option>
                        <option value="ALL">ALL</option>
                      </Field>

                      <div
                        className="text-danger small"
                        style={{ minHeight: "18px" }}
                      >
                        <ErrorMessage name="scheme" />
                      </div>
                    </div>
                  )}

                  <div style={{ marginLeft: "1rem", paddingTop: "27px" }}>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm rounded"
                    >
                      Get Report
                    </button>
                  </div>
                </div>
              </bie.Row>
            </Form>
          </FormikProvider>
          <bie.Col
            lg={12}
            md={12}
            xl={12}
            xxl={12}
            xs={12}
            sm={12}
            className="mb-4"
          >
            {instRepoTable && (
              <>
                {instRepoData?.length === 0 ? (
                  <center className="text-danger mt-4 h5">
                    {" "}
                    ***** No Data Found *****{" "}
                  </center>
                ) : (
                  <>
                    <div className="all-table-content table-responsive">
                      <div className="overal-stathead">
                        <span>Institution Details Report</span>
                      </div>
                      <CommonReactTable
                        data={instRepoData}
                        columns={instColumns}
                        filename="Institution Details Report"
                        headerName="Institution Details Report"
                        showPagination={false}
                        showPrint={true}
                        showExcel={true}
                        excelFileName="Institution_Report"
                      />
                    </div>
                  </>
                )}
              </>
            )}
          </bie.Col>

          {finRepoTable &&
            (finRepoData?.length === 0 ? (
              <center className="text-danger mt-4 h5">
                ***** No Data Found *****
              </center>
            ) : (
              <>
                <div className="overal-stathead">
                  <span>{schemeFormik?.values?.scheme}-Financial Report</span>
                </div>
                <div style={{ overflowX: "auto", width: "100%" }}>
                  {/* ACTIONS */}
                  <TableActions
                    tableRef={tableRef}
                    searchValue={search}
                    onSearchChange={setSearch}
                    showSearch={true}
                    showPrint={true}
                    showExcel={true}
                    excelFileName="Financial_Report"
                  />

                  <div style={{ overflowX: "auto", width: "100%" }}>
                    <table
                      ref={tableRef}
                      id="finance-table"
                      className="table table-bordered table-striped text-center"
                      style={{ fontSize: "0.9rem" }}
                    >
                      <thead>
                        <tr>
                          <th
                            colSpan={27}
                            style={{
                              textAlign: "center",
                              fontSize: "1rem",
                              backgroundColor: "#3b1600",
                              color: "white",
                            }}
                          >
                            {schemeFormik?.values?.scheme}-Financial Report
                          </th>
                        </tr>
                        <tr>
                          <th rowSpan={3} style={thStyle}>
                            Sl.No
                          </th>
                          <th rowSpan={3} style={thStyle}>
                            Institution Name
                          </th>
                          <th rowSpan={3} style={thStyle}>
                            RUSA Phase
                          </th>
                          <th rowSpan={3} style={thStyle}>
                            Component Name
                          </th>
                          <th colSpan={12} style={thStyle}>
                            Sub Component Details
                          </th>
                          <th colSpan={3} rowSpan={2} style={thStyle}>
                            Total
                          </th>
                        </tr>

                        <tr>
                          <th colSpan={3} style={thStyle}>
                            New Construction
                          </th>
                          <th colSpan={3} style={thStyle}>
                            Renovation
                          </th>
                          <th colSpan={3} style={thStyle}>
                            Equipment
                          </th>
                          <th colSpan={3} style={thStyle}>
                            Soft Component
                          </th>
                        </tr>

                        <tr>
                          {Array(4)
                            .fill(null)
                            .map((_, i) => (
                              <React.Fragment key={i}>
                                <th style={thStyle}>Amount Allocated</th>
                                <th style={thStyle}>Amount Utilised</th>
                                <th style={thStyle}>Balance Amount</th>
                              </React.Fragment>
                            ))}
                          <th style={thStyle}>Amount Allocated</th>
                          <th style={thStyle}>Amount Utilised</th>
                          <th style={thStyle}>Balance Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredData.length === 0 ? (
                          <tr>
                            <td colSpan={16} className="text-danger fw-bold">
                              ***** No Data Found *****
                            </td>
                          </tr>
                        ) : (
                          filteredData.map((row, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{row.inst_name}</td>
                              <td>{row.rusa_phase}</td>
                              <td>{row.comp_name}</td>

                              {/* New */}
                              <td>{row.new_amount_allocated}</td>
                              <td>{row.new_amount_utilised}</td>
                              <td>{row.new_balance_amount}</td>

                              {/* Renovation */}
                              <td>{row.renovation_amount_allocated}</td>
                              <td>{row.renovation_amount_utilised}</td>
                              <td>{row.renovation_balance_amount}</td>

                              {/* Equipment */}
                              <td>{row.equipment_amount_allocated}</td>
                              <td>{row.equipment_amount_utilised}</td>
                              <td>{row.equipment_balance_amount}</td>

                              {/* Soft */}
                              <td>{row.soft_amount_allocated}</td>
                              <td>{row.soft_amount_utilised}</td>
                              <td>{row.soft_balance_amount}</td>

                              {/* ✅ RIGHT SIDE TOTAL */}
                              <td>{row.total_allocated}</td>
                              <td>{row.total_utilised}</td>
                              <td>{row.total_balance}</td>
                            </tr>
                          ))
                        )}
                      </tbody>

                      {/* FOOTER */}
                      <tfoot>
                        <tr>
                          <td colSpan={4} className="fw-bold ">
                            {" "}
                            Total{" "}
                          </td>
                          {/* New Construction */}
                          <td>
                            {getTotal(filteredData, "new_amount_allocated")}
                          </td>
                          <td>
                            {getTotal(filteredData, "new_amount_utilised")}
                          </td>
                          <td>
                            {getTotal(filteredData, "new_balance_amount")}
                          </td>
                          {/* Renovation */}
                          <td>
                            {getTotal(
                              filteredData,
                              "renovation_amount_allocated",
                            )}
                          </td>
                          <td>
                            {getTotal(
                              filteredData,
                              "renovation_amount_utilised",
                            )}
                          </td>
                          <td>
                            {getTotal(
                              filteredData,
                              "renovation_balance_amount",
                            )}
                          </td>

                          {/* Equipment */}
                          <td>
                            {getTotal(
                              filteredData,
                              "equipment_amount_allocated",
                            )}
                          </td>
                          <td>
                            {getTotal(
                              filteredData,
                              "equipment_amount_utilised",
                            )}
                          </td>
                          <td>
                            {getTotal(filteredData, "equipment_balance_amount")}
                          </td>

                          {/* Soft Component */}
                          <td>
                            {getTotal(filteredData, "soft_amount_allocated")}
                          </td>
                          <td>
                            {getTotal(filteredData, "soft_amount_utilised")}
                          </td>
                          <td>
                            {getTotal(filteredData, "soft_balance_amount")}
                          </td>

                          {/* Total*/}
                          <td>
                            {filteredData.reduce(
                              (s, r) => s + r.total_allocated,
                              0,
                            )}
                          </td>
                          <td>
                            {filteredData.reduce(
                              (s, r) => s + r.total_utilised,
                              0,
                            )}
                          </td>
                          <td>
                            {filteredData.reduce(
                              (s, r) => s + r.total_balance,
                              0,
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </>
            ))}
        </bie.Container>
      </bie.Container>
    </>
  );
}

export default SchemewiseReport;
